import { useSearchParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Button, ButtonVariantEnum, ButtonTextColorVariantEnum } from 'components/Button'
import { QUICKSTART } from 'components/quickstart/constants'
import { QuickstartPages, PageToContentMap } from 'components/quickstart/models'
import { useModal } from 'hooks/useModal'

export const BottomControls = ({ pageToContentMap }: { pageToContentMap: PageToContentMap }) => {
  const { t } = useTranslation()
  const { closeModal, paramValue } = useModal(QUICKSTART)
  const [searchParams, setSearchParams] = useSearchParams()

  const quickstartPages = [...pageToContentMap.keys()]

  const currentStep = quickstartPages.indexOf(paramValue as QuickstartPages) ?? 0
  const nextStep = currentStep + 1
  const isFinalStep = nextStep === quickstartPages.length

  const onClickNext = () => {
    if (!isFinalStep) {
      const currentQueryParams = new URLSearchParams(searchParams)
      currentQueryParams.set(QUICKSTART, quickstartPages[nextStep])
      setSearchParams(currentQueryParams)
    } else {
      localStorage.removeItem(QUICKSTART)
      closeModal()
    }
  }

  return (
    <div className="h-[100px] mt-[20px] flex justify-between items-center">
      <Button
        variant={ButtonVariantEnum.Text}
        textColorVariant={ButtonTextColorVariantEnum.Muted}
        onClick={closeModal}
      >
        {t('quickstart.hideTools')}
      </Button>
      <Button
        variant={ButtonVariantEnum.Outlined}
        textColorVariant={ButtonTextColorVariantEnum.Primary}
        onClick={onClickNext}
      >
        {isFinalStep ? t('quickstart.completed') : t('quickstart.next')}
      </Button>
    </div>
  )
}
